import { getAmpConfig } from 'shared/config/amp-config';

export const getManageOnboardingInvitesUrl = () =>
  `${getAmpConfig().gateway}/moi`;
